import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { Campaign } from "../../models/campaign.model";
import { Division } from "../../models/division.model";
import { Organisation } from "../../models/organisation.model";
import { PermissionCheck } from "../../shared/permission";
import { DialogUtils } from "../../helper/dialog.helper";
import { SearchUtils } from "../../helper/search.helper";

let DivisionsComponent = {
    selector: "vcDivisions",
    templateUrl: "/angular/components/division/divisions.component.html",
    bindings: {},
    controller: class DivisionsController {
        private readonly $scope: any;
        private readonly $location: any;

        public activeCampaign: Campaign;
        public activeOrganisation: Organisation;
        private search: any;
        public active_tab: string = "list";
        public searchString: string = "";

        private readonly campaignDataProvider: CampaignDataProvider;
        private readonly dialog: DialogUtils;
        private readonly searchUtils: SearchUtils;
        public readonly permissionProvider: PermissionCheck;
        public showSearch: boolean;

        constructor(
            $scope: any,
            __app_type: any,
            $location: any,
            CampaignDataProvider: CampaignDataProvider,
            DialogUtils: DialogUtils,
            PermissionCheck: PermissionCheck,
            SearchUtils: SearchUtils
        ) {
            this.$scope = $scope;
            this.permissionProvider = PermissionCheck;
            this.campaignDataProvider = CampaignDataProvider;
            this.dialog = DialogUtils;
            this.searchUtils = SearchUtils;
            this.$location = $location;

            this.search = this.$location.search();
            this.active_tab = this.search.tab ? this.search.tab : "list";
            this.activeCampaign = this.campaignDataProvider.getActiveCampaign();
        }

        $onInit() {
            this.campaignDataProvider
                .getOrganisations()
                .then((organisation: Organisation) => {
                    this.activeOrganisation = organisation;
                });
        }

        tabChanged(tab: string): void {
            this.active_tab = tab;
            this.$location.search("tab", tab);
        }

        toggleSearch(): void {
            this.showSearch = !this.showSearch;
            if (!this.showSearch) {
                this.searchString = "";
            }
        }

        createDivision(division: Division, $event: any): void {
            this.dialog.show({
                component: "vc-division-create-dialog",
                targetEvent: $event,
                scope: this.$scope,
                clickOutsideToClose: false,
                multiple: false,
                locals: {
                    division: division,
                },
            });
        }
    },
};

angular
    .module("division")
    .component(DivisionsComponent.selector, DivisionsComponent);
